import React, { PropsWithChildren } from 'react';
import { Flex } from 'glints-aries/es';
import { Icon, PlainButton } from 'glints-aries/es/@next';
import { Neutral } from 'glints-aries/es/@next/utilities/colors';
import { space16, space24 } from 'glints-aries/es/@next/utilities/spacing';
import { FormattedMessage, MessageDescriptor } from 'react-intl';
import styled from 'styled-components';

const StyledCustomHeader = styled.div`
  background-image: linear-gradient(90deg, #ffedb1, #fff8e0);
  padding: ${space16} ${space24};
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const CloseButton = styled(PlainButton)`
  display: contents;
  padding: 0;
  svg {
    fill: ${Neutral.B40};
    width: 24px;
    height: 24px;

    :hover {
      fill: ${Neutral.B40};
    }
  }
`;

export const GlintsVIPCustomModalHeader = ({
  title,
  children,
  onClose,
}: {
  title: MessageDescriptor;
  onClose: () => void;
} & PropsWithChildren) => (
  <StyledCustomHeader>
    <Flex
      justifyContent="space-between"
      gap="10px"
      flexDirection="row"
      alignItems="center"
    >
      <Flex alignItems="center" gap="10px">
        <FormattedMessage {...title} />
        {children}
      </Flex>
      <CloseButton onClick={() => onClose()} aria-label="Close" role="button">
        <Icon name="ri-close" height={24} width={24} />
      </CloseButton>
    </Flex>
  </StyledCustomHeader>
);
